var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-item" }, [
    _c("div", { staticClass: "cart-item__left" }, [
      _c(
        "div",
        { staticClass: "cart-item__image" },
        [
          _c("ImgComponent", {
            attrs: { head_img: _vm.data.product.preview_img },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "cart-item__info" }, [
        _c(
          "div",
          { staticClass: "cart-item__title" },
          [
            _c("span", [_vm._v(_vm._s(_vm.data.product.title))]),
            _c("FavoriteComponent", { attrs: { product: _vm.data.product } }),
          ],
          1
        ),
        _c("span", { staticClass: "cart-item__price-one" }, [
          _vm._v(
            " цена за 1 штуку: " + _vm._s(_vm.data.product.price_retail) + " ₽"
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "cart-item__right" }, [
      _c("div", { staticClass: "cart-item__counter" }, [
        _c(
          "button",
          {
            staticClass: "btn cart-item__counter-plus",
            attrs: { disabled: _vm.count === 1 },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.change(_vm.count - 1)
              },
            },
          },
          [_c("IconComponent", { attrs: { name: "minus" } })],
          1
        ),
        _c("span", [_vm._v(" " + _vm._s(_vm.count ? _vm.count : "") + " ")]),
        _c(
          "button",
          {
            staticClass: "btn cart-item__counter-minus",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.change(_vm.count + 1)
              },
            },
          },
          [_c("IconComponent", { attrs: { name: "plus" } })],
          1
        ),
      ]),
      _c("div", { staticClass: "cart-item__price" }, [
        _c("div", { staticClass: "cart-item__price-info" }, [
          _c("span", { staticClass: "cart-item__price-new" }, [
            _vm._v(_vm._s(_vm.data.product.price_retail * _vm.count) + " ₽"),
          ]),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.data.product.price_without_discount,
                  expression: "data.product.price_without_discount",
                },
              ],
              staticClass: "cart-item__price-old",
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.data.product.price_without_discount * _vm.count)
                ),
              ]),
              _c("span", [_vm._v("₽")]),
            ]
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "cart-item__remove-from-cart",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.change(0)
              },
            },
          },
          [_c("span", [_vm._v("Убрать из корзины")])]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }